<template>
    <div class="vx-row">
        <div class="vx-col md:w-2/2 w-full mb-base" v-if="renderComponent">
            <vx-card title="Add User">
                <div class="vx-row mb-2" v-if=currentUser.isInternal>
                    <div class="vx-col w-full">
                        <ul class="centerx">
                            <li>
                                <vs-radio id="rdo-user-internal" v-model="NewUserGroup" vs-value="aino" @change="updateRolesData">
                                    Internal user
                                </vs-radio>
                            </li>
                            <li>
                                <vs-radio id="rdo-user-merchant" v-model="NewUserGroup" vs-value="merchant"
                                          @change="updateRolesData">Merchant user
                                </vs-radio>
                            </li>
                            <li>
                                <vs-radio id="rdo-user-issuer" v-model="NewUserGroup" vs-value="issuer"
                                          @change="updateRolesData">Issuer user
                                </vs-radio>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="vx-row mb-6" v-if="NewUserGroup === 'merchant'">
                    <div class="vx-col w-full">
                        <vs-select id="cbo-merchant" name="Merchant" description-text="Select a merchant" placeholder="Select merchant"
                                   label="Merchant" v-model="merchant_id" v-validate="'required'">
                            <vs-select-item v-bind:id="'cbo-merchant-'+merchant.id" :key="merchant.id" :value="merchant.id" :text="merchant.full_name"
                                            v-for="merchant in merchants"/>
                        </vs-select>
                        <span class="text-danger text-sm">{{ errors.first('Merchant') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-6" v-if="NewUserGroup === 'issuer'">
                    <div class="vx-col w-full">
                        <vs-select id="cbo-issuer" name="Issuer" description-text="Select a issuer" placeholder="Select issuer"
                                   label="Issuer" v-model="issuer_id" v-validate="'required'">
                            <vs-select-item v-bind:id="'cbo-issuer'+issuer.id" :key="issuer.id" :value="issuer.id" :text="issuer.name"
                                            v-for="issuer in issuers"/>
                        </vs-select>
                        <span class="text-danger text-sm">{{ errors.first('Issuer') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full">
                        <vs-input id="txt-username" class="w-full" name="Name" icon-pack="feather" icon="icon-user" icon-no-border
                                  label-placeholder="Username" v-model="data.username"
                                  v-validate="'required'"/>
                        <span class="text-danger text-sm">{{ errors.first('Name') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full">
                        <vs-input id="txt-email" type="email" name="Email" class="w-full" icon-pack="feather" icon="icon-mail"
                                  icon-no-border
                                  label-placeholder="Email" v-model="data.email"
                                  v-validate="'required|email'"/>
                        <span class="text-danger text-sm">{{ errors.first('Email') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <vs-input id="txt-password" type="password" name="Password" class="w-full" icon-pack="feather" icon="icon-lock"
                                  icon-no-border
                                  label-placeholder="Password" v-model="data.password"
                                  v-validate="'required|min:8|verify_password'"/>
                        <span class="text-danger text-sm">{{ errors.first('Password') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <vs-select id="cbo-role" name="User roles" description-text="Select a user roles" placeholder="Select role"
                                   label="User roles" v-model="data.role_id" v-validate="'required'">
                            <vs-select-item v-bind:id="'cbo-role-'+role.id" :key="role.id" :value="role.id" :text="role.name" v-for="role in roles"/>
                        </vs-select>
                        <span class="text-danger text-sm">{{ errors.first('User roles') }}</span>
                    </div>
                </div>
                <br/>
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <vs-button id="btn-save" color="success" type="filled" class="mb-2" icon-pack="feather" icon="icon-save"
                                   @click.prevent="addUser">Save
                        </vs-button>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
    import AxiosCall from "@/global/AxiosCall";
    import {url} from '@/configs/apiUrl'

    export default {
        name: "DeviceRegistration",
        data() {
            return {
                renderComponent: true,
                NewUserGroup: "aino",
                data: {
                    username: "",
                    email: "",
                    password: "",
                    role_ids: [],
                    role_id: '',
                    merchant_id: '',
                    issuer_id: '',
                },
                roles: [],
                merchant_id: '',
                issuer_id: '',
                currentUser: {
                    id: 0,
                    group: "",
                    isInternal: false,
                },
                merchants: [],
                issuers: [],
                auditUser: {
                    user_id: "",
                    session_id: "",
                    user_name: "",
                    menu: "",
                    activity: "",
                    data_before: {},
                    data_after: {},
                },
            }
        },
        methods: {
            openLoading() {
                this.$vs.loading({
                    type: 'default',
                })
            },
            forceRerender() {
                // Remove my-component from the DOM
                this.renderComponent = false;

                this.$nextTick(() => {
                    // Add the component back in
                    this.renderComponent = true;
                });
            },
            warning(title, text) {
                this.$vs.notify({
                    title: title,
                    text: text,
                    color: 'warning',
                    position: 'top-right'
                })
            },
            success(title, text) {
                this.$vs.notify({
                    title: title,
                    text: text,
                    color: 'success',
                    position: 'top-right'
                })
            },
            danger(title, text) {
                this.$vs.notify({
                    title: title,
                    text: text,
                    color: 'danger',
                    position: 'top-right'
                })
            },
            addUser() {
                this.auditUser = {
                    user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                    session_id: parseInt(localStorage.getItem('sessID')),
                    user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                    menu:      "User Management",
                    activity: "Add User",
                    data_before: {},
                    data_after: {"username" : this.data.username, "password" : "*******", "email": this.data.email, "role_ids": [this.data.role_id],"role_id": this.data.role_id, "merchant_id": this.merchant_id,"issuer_id": this.issuer_id}
                }
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.openLoading()

                        this.data.role_ids = [this.data.role_id]
                        if (this.NewUserGroup === 'aino')
                            this.data.merchant_id = 0
                        else {
                            this.data.merchant_id = this.merchant_id
                            this.data.issuer_id = this.issuer_id
                        }

                        AxiosCall.Post(url.svd.user.register, this.data).then(resp => {
                            this.$vs.loading.close()
                            if (resp.code === 200) {
                                this.success('Success', "User successfully registered")
                                this.data = {username: "", email: "", password: "", role_id: ''}
                                this.NewUserGroup = 'aino'
                                this.forceRerender()
                                this.$store.dispatch('createAuditTrail', this.auditUser)
                                return
                            }

                            this.danger('Error', 'Add user failed')
                        }).catch((e) => {
                            console.log(e)
                            this.$vs.loading.close()
                            this.danger('Error', 'Add user failed')
                        })
                    }
                })
            },
            updateRolesData() {
                this.data.role_id = ''
                let group = this.NewUserGroup
                this.data.merchant_id = ''
                this.data.issuer_id = ''
                this.merchant_id = ''
                this.issuer_id = ''

                AxiosCall.Get(url.svd.roles.list + "?group=" + group).then(response => {
                    console.log(response)
                    if (response.code == 200) {
                        this.roles = response.data
                    } else {
                        this.danger("Error", "Retrieve roles data failed (" + response.message + ")")
                    }
                })
            },
        },
        mounted() {
            try {
                var userData = JSON.parse(localStorage.getItem("userInfo"))
                this.currentUser.id = userData.id
                var authToken = userData.access_token.token
                AxiosCall.GetUserFromToken(url.svd.auth.me, {authToken: authToken}).then(response => {
                    if (response.data.code == 200) {

                        //todo remove condition
                        if (typeof response.data.data.roles[0] == 'string') {
                            this.currentUser.group = 'aino'
                        } else {
                            this.currentUser.group = response.data.data.roles[0].group
                        }

                        if (this.currentUser.group === 'aino') {
                            this.currentUser.isInternal = true
                        }

                        AxiosCall.Get(url.svd.roles.list + "?group=" + this.currentUser.group).then(response => {
                            if (response.code == 200) {
                                this.roles = response.data
                            } else {
                                this.danger("Error", "Retrieve roles data failed (" + response.message + ")")
                            }
                        })
                    } else {
                        this.danger("Error", "Retrieve user data failed (" + response.message + ")")
                    }
                })
            } catch (e) {
                console.log(e)
            }

            AxiosCall.Get(url.svd.merchant.list).then(response => {
                if (response.code == 200) {
                    this.merchants = response.data
                } else {
                    this.danger("Error", "Retrieve roles data failed (" + response.message + ")")
                }
            })

            AxiosCall.Get(url.backoffice.issuer.list).then(response => {
                if (response.code == 200) {
                    this.issuers = response.data
                } else {
                    this.danger("Error", "Retrieve roles data failed (" + response.message + ")")
                }
            })
        },
        props: {
            id_merchant: {
                type: Number
            }
        }
    }
</script>

<style scoped>

</style>